import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ARCHETYPE_REFLECTIONS } from '../../data/archetypeReflections';
import { REFLECTION_PROMPTS, FALLBACK_REFLECTIONS } from '../../data/todayData';

/* ─── Daily Reflection (replaces Affirmation) ─── */
const DailyReflection: React.FC<{ moonAttribute?: string; archetype?: string }> = ({ moonAttribute, archetype }) => {
  const reflectionNavigate = useNavigate();
  const [copied, setCopied] = useState(false);

  const dayOfYear = Math.floor((Date.now() - new Date(new Date().getFullYear(), 0, 0).getTime()) / 86400000);
  let reflection: string;
  const archetypePool = archetype ? ARCHETYPE_REFLECTIONS[archetype] : null;
  if (archetypePool && archetypePool.length > 0) {
    reflection = archetypePool[dayOfYear % archetypePool.length];
  } else if (moonAttribute && REFLECTION_PROMPTS[moonAttribute]) {
    reflection = REFLECTION_PROMPTS[moonAttribute];
  } else {
    reflection = FALLBACK_REFLECTIONS[dayOfYear % FALLBACK_REFLECTIONS.length];
  }

  const handleCopy = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigator.clipboard.writeText(reflection).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="glow-reflection" onClick={() => { localStorage.setItem('zeal_daily_reflection', reflection); localStorage.setItem('zeal_daily_reflection_attr', moonAttribute || 'Depth'); localStorage.setItem('zeal_open_journal', 'true'); reflectionNavigate('/journey'); }} style={{
      position: 'relative', padding: '18px 16px', borderRadius: '18px',
      background: 'rgba(72,201,176,0.03)',
      textAlign: 'center', marginBottom: '24px', cursor: 'pointer',
    }}>
      <p style={{ fontFamily: 'Cinzel, serif', fontSize: '16px', letterSpacing: '2px', textTransform: 'uppercase', color: '#f4e4c1', fontWeight: 700, margin: '0 0 4px' }}>
        Embrace the Journey
      </p>
      {archetype && (
        <p style={{ fontSize: '9px', letterSpacing: '2px', textTransform: 'uppercase', color: 'rgba(201,168,76,0.65)', margin: '0 0 10px' }}>
          for {archetype}s
        </p>
      )}
      <p style={{
        fontFamily: "Cinzel, serif", fontSize: '15px', fontStyle: 'italic',
        color: 'rgba(244,228,193,0.85)', lineHeight: 1.6, margin: '0 0 12px',
        letterSpacing: '0.2px', padding: '0 4px',
      }}>
        "{reflection}"
      </p>
      <button
        onClick={handleCopy}
        style={{
          fontSize: '10px', color: copied ? '#48c9b0' : 'rgba(201,168,76,0.75)',
          background: 'none', border: `1px solid ${copied ? 'rgba(72,201,176,0.3)' : 'rgba(201,168,76,0.25)'}`,
          padding: '4px 12px', borderRadius: '12px', cursor: 'pointer',
          transition: 'all 0.3s', letterSpacing: '1px', textTransform: 'uppercase',
        }}
      >
        {copied ? '✓ Copied' : 'Copy'}
      </button>
    </div>
  );
};

export default DailyReflection;
